function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  id: "Confidential_waste",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 283.5 283.5",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M91.9 127.8h14.6v42.6H91.9zM176.9 127.8h14.6v42.6h-14.6zM120.2 127.8h14.5v56.7h-14.5zM148.5 127.8H163v56.7h-14.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M234.1 92.3h-21.6V54.9L157.3 0H70.6v92.3H49.3v28.3h7.2l.2 162.8h170.1l-.2-162.8h7.5V92.3zm-35.7 162.6H85.3l-.2-134.1h113.1l.2 134.1zM186.7 49.7H156V19.1l30.7 30.6zM85.1 14.5h56.4v49.7h56.6v28.1h-113V14.5z"
})));